import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Tooltip
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

const KinkList = ({ kinks, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ width: '100%' }}>
      <Table size="small" stickyHeader sx={{ tableLayout: 'fixed', width: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 220 }}>Kink Name</TableCell>
            <TableCell>Instruction</TableCell>
            <TableCell align="right" sx={{ width: 112, whiteSpace: 'nowrap' }}>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {kinks.map((kink) => (
            <TableRow key={kink._id} hover>
              <TableCell sx={{ verticalAlign: 'top', wordBreak: 'break-word' }}>
                <strong>{kink.name}</strong>
              </TableCell>
              <TableCell sx={{ verticalAlign: 'top' }}>
                <Box
                  sx={{
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    color: 'text.secondary',
                    fontSize: '0.8rem',
                    lineHeight: 1.4,
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-wrap'
                  }}
                >
                  {kink.instruction}
                </Box>
              </TableCell>
              <TableCell align="right" sx={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>
                <Box
                  sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 0.25
                  }}
                >
                  <Tooltip title="Edit">
                    <IconButton
                      onClick={() => onEdit(kink)}
                      color="primary"
                      size="small"
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      onClick={() => onDelete(kink._id)}
                      color="error"
                      size="small"
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {kinks.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} align="center">
                No kinks found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default KinkList;